import { render, staticRenderFns } from "./images2.vue?vue&type=template&id=b5fa1d26&scoped=true"
import script from "./images2.vue?vue&type=script&lang=js"
export * from "./images2.vue?vue&type=script&lang=js"
import style0 from "./images2.vue?vue&type=style&index=0&id=b5fa1d26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fa1d26",
  null
  
)

export default component.exports